export default {
  state: {
    server_msg: {
      server_ok: null,
      server_info: null,
      server_error: null,
      connection_error: null
    }
  },
  getters: {
    serverMsg(state) {
      return state.server_msg
    }
  },
  mutations: {
    setServerMsg(state, { server_ok, server_info, server_error, connection_error }) {
      state.server_msg.server_ok = null,
        state.server_msg.server_info = null,
        state.server_msg.server_error = null,
        state.server_msg.connection_error = null,

        state.server_msg.server_ok = server_ok,
        state.server_msg.server_info = server_info,
        state.server_msg.server_error = server_error,
        state.server_msg.connection_error = connection_error
    },
    clearServerMsg(state) {
      state.server_msg.server_ok = null,
        state.server_msg.server_info = null,
        state.server_msg.server_error = null,
        state.server_msg.connection_error = null
    }
  },
  actions: {
    async serverCall({ dispatch }, { typeCall, pathVariable, data, dataMultipartForm }) {
      //const urlBase = "http://localhost:3340/lehrerin";
      //const urlBase = "http://194.13.83.126:3340/lehrerin";
      const urlBase = process.env.VUE_APP_SERVER_BACKEND_URL_BASE;
      let pathVar = (pathVariable) ? pathVariable : "";
      let jsonRequest = (data) ? data : null;
      let multipartFormRequest = (dataMultipartForm) ? dataMultipartForm : null;
      let url;
      switch (typeCall) {
        case "login":
          url = urlBase + "/login/" + pathVar;
          return await dispatch("callAPI", { url, jsonRequest });
          
        case "logout":
          url = urlBase + "/logout/" + pathVar;
          return await dispatch("callAPI", { url, jsonRequest });

        case "register":
          url = urlBase + "/register/" + pathVar;
          return await dispatch("callAPI", { url, jsonRequest });

        case "changeUserData":
          url = urlBase + "/changeuserdata/" + pathVar;
          return await dispatch("callAPI", { url, jsonRequest });

        case "getCourses":
          url = urlBase + "/courses/" + pathVar;
          return await dispatch("callAPI", { url, jsonRequest });

        case "getCourseVideos":
          url = urlBase + "/course/videos/" + pathVar;
          return await dispatch("callAPI", { url, jsonRequest });

        case "getCourseModes":
          url = urlBase + "/course/modes/" + pathVar;
          return await dispatch("callAPI", { url, jsonRequest });

        case "getCourseModeSatzes":
          url = urlBase + "/course/mode/satzes/" + pathVar;
          return await dispatch("callAPI", { url, jsonRequest });

        case "getCourseModeRegimeProgress":
          url = urlBase + "/course/mode/mode_regime/progress/" + pathVar;
          return await dispatch("callAPI", { url, jsonRequest }); 

        case "getCourseModeRegimeNextTask":
          url = urlBase + "/course/mode/mode_regime/next/" + pathVar;
          return await dispatch("callAPI", { url, jsonRequest });

        case "getCourseModeRegimeTipp":
          url = urlBase + "/course/mode/mode_regime/tipp/" + pathVar;
          return await dispatch("callAPI", { url, jsonRequest });

        case "getCourseVideosSetViewed":
          url = urlBase + "/course/videos/viewed/" + pathVar;
          return await dispatch("callAPI", { url, jsonRequest });  

        case "getCourseModeRegimeVerifyResult":
          url = urlBase + "/course/mode/mode_regime/verify/" + pathVar;
          return await dispatch("callAPI", { url, jsonRequest });

        case "getCourseModeRegimeAudioRecognize":
          url = urlBase + "/course/mode/mode_regime/audio/" + pathVar;
          return await dispatch("callAPI", { url, multipartFormRequest });
      }

    },

    async callAPI({ commit }, { url, jsonRequest, multipartFormRequest }) {      
      let objectRequest = {
        method: "POST",
        body: null,
        headers: {
          "Content-type": "text/plain",
          "Accept": "application/json"
        }
      };      

      if (jsonRequest) {
        objectRequest.body = JSON.stringify(jsonRequest);      
      } else if (multipartFormRequest){                        
        objectRequest.body = multipartFormRequest;  
        delete objectRequest.headers['Content-type'];      
      } else {
        return;
      }

      let objectResponse = {
        bodyJson: null,
        headers: {
          server_ok: null,
          server_info: null,
          server_error: null,
          connection_error: null
        }
      };           

      try {
        const response = await fetch(url, objectRequest);
        try {
          const json = await response.json();
          objectResponse.headers.server_ok = response.headers.get("server_ok");
          commit("setServerMsg", {
            server_ok: objectResponse.headers.server_ok
          })
          objectResponse.bodyJson = json;
          return objectResponse;

        } catch (error) {
          objectResponse.headers.server_info = response.headers.get("server_info");
          objectResponse.headers.server_error = response.headers.get("server_error");
          commit("setServerMsg", {
            server_info: objectResponse.headers.server_info,
            server_error: objectResponse.headers.server_error
          })
        }

      } catch (error) {
        objectResponse.headers.connection_error = "error_connection";
        commit("setServerMsg", {
          connection_error: objectResponse.headers.connection_error,
        });
        commit("setErrorMain", "error_connection");
        return objectResponse;
      }

    }
  }
}

